import type { UpdateTemplateRequestBody } from "@/common/types/templates";

import { useState } from "react";

import { updateTemplate as updateTemplateService } from "@/services/templates";

export const useUpdateTemplate = (): {
  updateTemplate: (body: UpdateTemplateRequestBody) => Promise<void>;
  result: boolean | null;
  loading: boolean;
  error: boolean;
} => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const updateTemplate = async (
    body: UpdateTemplateRequestBody
  ): Promise<void> => {
    setLoading(true);
    setError(false);

    try {
      await updateTemplateService(body);

      setResult(true);
      setLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  return { updateTemplate, result, loading, error };
};
